import { useState } from 'react';

type Lines = Record<string, { topLeftX: number; topLeftY: number; bottomRightX: number; bottomRightY: number }>;

/**
 * An interface representing the canvas of a mindmap and its data.
 */
export interface Canvas {
  /**
   * The lines drawn on the canvas.
   */
  lines: Lines;

  /**
   * A function that draws a line on the canvas.
   *
   * @param id The ID of the line to create.
   * @param topLeftX The x-coordinate of the top left point of the line to draw.
   * @param topLeftY The y-coordinate of the top left point of the line to draw.
   * @param bottomRightX The x-coordinate of the bottom right point of the line to draw.
   * @param bottomRightY The y-coordinate of the bottom right point of the line to draw.
   */
  addLine: (id: string, topLeftX: number, topLeftY: number, bottomRightX: number, bottomRightY: number) => void;

  /**
   * A function that removes one or more lines from the canvas.
   *
   * @param id The ID of the line(s) to remove.
   * @returns
   */
  removeLine: (...id: string[]) => void;
}

export const useMindmapCanvas = (): Canvas => {
  const [lines, setLines] = useState<Lines>({});

  const addLine = (id: string, topLeftX: number, topLeftY: number, bottomRightX: number, bottomRightY: number) => {
    setLines((lines) => ({
      ...lines,
      [id]: { topLeftX, topLeftY, bottomRightX, bottomRightY },
    }));
  };

  const removeLine = (...ids: string[]) => {
    setLines((lines) => {
      ids.forEach((id) => delete lines[id]);
      return lines;
    });
  };

  return { addLine, removeLine, lines };
};
